import React from 'react'
import { Navigate } from 'react-router-dom'

import { isAdminUser } from '../utils/adminUtils'

interface AdminRouteProps {
  user: unknown
  children: React.ReactElement
}

function AdminRoute({ user, children }: AdminRouteProps) {
  return isAdminUser(user)
    ? children
    : <Navigate to="/dashboard" replace />
}

export default AdminRoute
